<template>
    <transition name="fade">
        <div class="page-result-review-score" v-show="show && !loading && !previousFeedback">
            <div class="page-result-review-score__close" v-on:click="close">
                <icon name="close" width="14" height="14" />
            </div>
            <div class="page-result-review-score__header">
                Насколько вы удовлетворены процессом верификации?
            </div>
            <div class="page-result-review-score__content">
                <div class="page-result-review-score__content-stars">
                    <icon
                        v-for="n in 5"
                        :key="n"
                        v-bind:name="n <= score ? 'star' : 'star-empty'"
                        v-on:click="setScore(n)"
                    />
                </div>
                <div class="page-result-review-score__content-answers" v-show="showAnswers">
                    <div class="page-result-review-score__content-answers-title">Укажите причину:</div>
                    <ui-checkbox-with-text
                        v-for="q in answers"
                        :key="q.id"
                        v-bind:checked="selectedId === q.id"
                        v-on:change="setAnswer(q.id)"
                    >
                        {{ q.text }}
                    </ui-checkbox-with-text>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { IdxStatus } from '~/constants';
import { mainClient } from '~/network';

export default {
    name: 'page-result-review-score',
    data: () => ({
        loading: true,
        show: false,
        score: 0,
        selectedId: null,
        previousFeedback: null,
        feedbackTimer: null,
    }),
    computed: {
        showAnswers() {
            return this.score > 0 && this.score <= 3;
        },
        answers() {
            return [
                {
                    id: 0,
                    text: 'Процесс занял слишком много времени',
                },
                {
                    id: 1,
                    text: 'Документы не распознавались',
                },
                {
                    id: 2,
                    text: 'Сложно или непонятно, что делать',
                },
                {
                    id: 3,
                    text: 'Не уверен(а) в безопасности данных',
                },
                {
                    id: 4,
                    text: 'Другое',
                },
            ];
        },
        selectedAnswer() {
            return this.answers.find(q => q.id === this.selectedId);
        },
    },
    methods: {
        close() {
            this.updateFeedback({ closed: true });
        },
        setScore(n) {
            this.score = n;
            this.updateFeedback({ rating: n }, n >= 4);
        },
        setAnswer(id) {
            this.selectedId = id;
            this.updateFeedback({ answer: this.selectedAnswer?.text || '' });
        },
        async getFeedback() {
            const { data, error, status } = await mainClient.users.requests.getVerificationFeedback();
            if (error) {
                console.error(error, status);
            } else {
                this.previousFeedback = data;
            }
            this.loading = false;
        },
        async updateFeedback(score = {}, close = true) {
            const { error, status } = await mainClient.users.requests.updateVerificationFeedback(score);
            if (error) {
                console.error(error, status);
                this.show = false;
            } else {
                if (close) {
                    this.show = false;
                }
            }
        },
        async createFeedback() {
            const stateResponse = await mainClient.users.requests.getIdxVerificationState();
            if (stateResponse.error) {
                console.error(stateResponse.error, stateResponse.status);
                return;
            }
            if (stateResponse.data?.status === IdxStatus.PROCESSING) {
                this.feedbackTimer = window.setTimeout(this.createFeedback, 2000);
                return;
            }
            if (!stateResponse.data || stateResponse.data.status === IdxStatus.RETRY_REQUIRED) {
                return;
            }

            const { error, status } = await mainClient.users.requests.createVerificationFeedback();
            if (error) {
                console.error(error, status);
            } else {
                this.show = true;
            }
        },
    },
    async mounted() {
        await this.getFeedback();
        if (!this.previousFeedback) {
            this.feedbackTimer = window.setTimeout(this.createFeedback, 2000);
        }
    },
    beforeDestroy() {
        window.clearTimeout(this.feedbackTimer);
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-result-review-score {
    .transition-fade();

    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    max-width: 444px;
    padding: 20px 8px;

    border: 1px solid @color-gray-light-secondary;
    border-radius: @border-radius-md;

    background-color: white;
    overflow: hidden;

    &__close {
        position: absolute;
        top: 8px;
        right: 8px;
        cursor: pointer;
    }
    &__header {
        .typography-small();
        font-weight: bold;
    }
    &__content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        padding-top: 14px;
        overflow: hidden;
        &-stars {
            display: flex;
            gap: 6px;
            font-size: 3.6rem;
            color: @color-primary;
            svg {
                cursor: pointer;
            }
        }
        &-answers {
            display: flex;
            flex-direction: column;
            gap: 12px;
            &-title {
                .typography-heading();

                align-self: flex-start;
            }
        }
        &-text {
            .typography-medium();
        }
    }
    &__media {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
        flex-shrink: 0;
        padding-top: 36px;
        img {
            height: 36px;
        }
    }
}
</style>
